import { QRCodeCanvas } from "qrcode.react";
import { Card, CardContent } from "@/components/ui/card";
import { QrCode } from "lucide-react";

/**
 * Lean success receipt: shows the drafted-on date, a short WillSeva reference
 * code, and a QR that opens the secure mobile download page.
 * Payment protection is enforced server-side — the QR target only renders
 * after /api/payments/status returns paid=true.
 */
export default function SuccessReceipt({ willId, paymentId, createdAt }) {
  if (!willId) return null;

  const downloadUrl = `${window.location.origin}/d/${willId}`;
  const ref = `WSV-${(willId || "").slice(0, 8).toUpperCase()}`;
  const draftedOn = createdAt
    ? new Date(createdAt).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : new Date().toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

  return (
    <Card
      className="mt-4 border-[#0A1128]/10 shadow-sm"
      data-testid="success-receipt"
    >
      <CardContent className="flex flex-col gap-5 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
        <div className="space-y-1.5">
          <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-gold">
            <QrCode size={12} /> Drafted on WillSeva
          </div>
          <div className="font-serif text-xl text-navy" data-testid="receipt-drafted-on">
            {draftedOn}
          </div>
          <div className="mt-1 grid gap-x-6 gap-y-1 text-xs text-[#4A5568] sm:grid-cols-2">
            <div>
              Reference{" "}
              <span className="font-mono text-navy" data-testid="receipt-ref">
                {ref}
              </span>
            </div>
            {paymentId && (
              <div>
                Payment{" "}
                <span className="font-mono text-navy">{paymentId}</span>
              </div>
            )}
          </div>
          <p className="mt-2 max-w-md text-xs text-[#4A5568]">
            Scan the QR with your phone to open the secure download page.
            Downloads remain payment-protected.
          </p>
        </div>
        <div
          className="self-center rounded-md border border-[#0A1128]/10 bg-white p-3"
          data-testid="receipt-qr"
        >
          <QRCodeCanvas
            value={downloadUrl}
            size={104}
            bgColor="#FFFFFF"
            fgColor="#0A1128"
            level="M"
            includeMargin={false}
          />
        </div>
      </CardContent>
    </Card>
  );
}
